import React, { useEffect, useCallback, useState, useRef } from "react";
import NotificationAlert from "react-notification-alert";
import { Button, Card, Container, Row, Col, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getListCommandeLivraison } from "../../Redux/livraisonReduce";
import { getProformaDate } from "../../Redux/proformaReduce";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
// FullCalendar imports
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

function ListCalendrierLivraison({ client }) {
  document.title = "Calendrier de livraison";
  const dispatch = useDispatch();
  const navigate = useHistory();
  const notificationAlertRef = useRef(null);

  const [entities, setEntities] = useState([]);
  const [proforma, setProforma] = useState([]);
  const [loader, setLoader] = useState(true);
  const [selectedGrossiste, setSelectedGrossiste] = useState("all");
  const lang = window.localStorage.getItem("lang");
  const annee = localStorage.getItem("annee");

  const notify = (place, msg, type) => {
    notificationAlertRef.current.notificationAlert({
      place: place,
      message: <div>{msg}</div>,
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    });
  };

const fileName = `calendrier_livraison_${new Date()
  .toISOString()
  .slice(0, 10)}.xlsx`;

const exportToExcel = async () => {
  const filteredData = [
    ...entities.filter(
      e =>
        selectedGrossiste === "all" ||
        e.RaisonSocial === selectedGrossiste
    ),
    ...proforma.filter(
      e =>
        selectedGrossiste === "all" ||
        e.RaisonSocial === selectedGrossiste
    )
  ]
    .map(item => ({
      DateLivraison: item.DateLivraison || item.date_enlevement || null,
      Grossiste:
        item.RaisonSocial ||
        item.RaisonSocial ||
        "",
      Numero: item.NumCommande || item.NumCommande || ""
    }))
    .sort((a, b) => new Date(a.DateLivraison) - new Date(b.DateLivraison));

  if (!filteredData.length) {
    alert("Aucune donnée à exporter");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Calendrier");

  // Définition colonnes
  worksheet.columns = [
    { header: "Date Livraison", key: "DateLivraison", width: 18 },
    { header: "Grossiste", key: "Grossiste", width: 30 },
    { header: "Numéro Commande", key: "Numero", width: 20 }
  ];

  // Style header
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).alignment = { horizontal: "center" };

  // Ajout des lignes
  filteredData.forEach(item => {
    const row = worksheet.addRow(item);

    // Format date
    if (item.DateLivraison) {
      row.getCell("DateLivraison").value = new Date(item.DateLivraison);
      row.getCell("DateLivraison").numFmt = "dd/mm/yyyy";
    }
  });

  // Bordures (optionnel mais propre)
  worksheet.eachRow(row => {
    row.eachCell(cell => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  saveAs(blob, fileName);
};

  const getLigne = useCallback(async () => {
    setLoader(true);
    try {
      // Fetch commandes livraison
      const list = await dispatch(getListCommandeLivraison({ id_user: 0, etat: 2, annee, client }));
      setEntities(list.payload || []);

      // Fetch proforma
      const list2 = await dispatch(getProformaDate({ id_user: 0, etat: 2, annee, client }));
      setProforma(list2.payload || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      notify("tr", "Erreur lors de la récupération des données", "danger");
    } finally {
      setLoader(false);
    }
  }, [dispatch, client, annee]);

  useEffect(() => {
    getLigne();
  }, [getLigne]);

  const onDetailClick = (id_livraison, NumCommande) => {
    navigate.push(`${client}/detailsLivCmd/${NumCommande}/${id_livraison}`);
  };

  const onDetailClickPro = (id) => {
    navigate.push(`${client}/detailsLivraisonProforma/${id}`);
  };

  const uniqueGrossistes = Array.from(
    new Set([
      ...entities.map(e => e.RaisonSocial),
      ...proforma.map(e => e.RaisonSocial)
    ])
  ).filter(Boolean);

  return (
    <Container fluid>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Row>
        <Col md="12">
          <Card>
            <Card.Header>
              <Card.Title as="h4">
                Calendrier de livraison
                <Button
                  className="btn-export mr-1 float-right"
                  type="button"
                  onClick={exportToExcel}
                  style={{ cursor: "pointer", fontSize: 14 }}
                >
                  Exporter calendrier
                </Button>
              </Card.Title>
            </Card.Header>
            <Card.Body className="calendar-style">
              {/* Filter Grossiste */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '20px',
                  backgroundColor: '#f9f9f9',
                  padding: '12px 16px',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
                }}
              >
                <label htmlFor="grossisteSelect" style={{ fontWeight: 'bold', color: '#333' }}>
                  Filtrer par grossiste :
                </label>

                <select
                  id="grossisteSelect"
                  value={selectedGrossiste}
                  onChange={(e) => setSelectedGrossiste(e.target.value)}
                  style={{
                    padding: '8px 12px',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                    outline: 'none',
                    backgroundColor: '#fff',
                    color: '#333',
                    cursor: 'pointer',
                    transition: 'border-color 0.2s ease',
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3285c6'}
                  onBlur={(e) => e.target.style.borderColor = '#ccc'}
                >
                  <option value="all">Tous les grossistes</option>
                  {uniqueGrossistes.map((grossiste, index) => (
                    <option key={index} value={grossiste}>{grossiste}</option>
                  ))}
                </select>
              </div>

              {/* Calendar */}
              {!loader ? (
                <FullCalendar
                  plugins={[dayGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  locale={lang === "fr" ? "fr" : "en"}
                  events={[
                    ...entities
                      .filter(e => selectedGrossiste === "all" || e.RaisonSocial === selectedGrossiste)
                      .map(e => ({
                        title: e.NumCommande,
                        date: e.DateLivraison,
                        id: e.id,
                        extendedProps: {
                          Raison_sociale: e.RaisonSocial || "",
                          NumCommande: e.NumCommande,
                          Date_expedition: e.DateLivraison,
                          id_livraison: e.NumLivraison,
                        }
                      })),
                    ...proforma
                      .filter(e => selectedGrossiste === "all" || e.proformas?.Raison_sociale === selectedGrossiste)
                      .map(e => ({
                        title: e.num_commande,
                        date: e.proformas.date_enlevement,
                        id: e.id,
                        extendedProps: {
                          Raison_sociale: e.proformas?.Raison_sociale || "",
                          NumCommande: e.num_commande,
                          Date_expedition: e.proformas?.date_enlevement,
                          isProforma: true
                        }
                      }))
                  ]}
                  eventContent={(eventInfo) => {
                    const { title, id } = eventInfo.event;
                    const raison = eventInfo.event.extendedProps.Raison_sociale;
                    const isProforma = eventInfo.event.extendedProps.isProforma;
                    const NumCommande = eventInfo.event.extendedProps.NumCommande;
                    const id_livraison = eventInfo.event.extendedProps.id_livraison;

                    return (
                      <div style={{ fontSize: '0.8rem' }}>
                        <b>{raison}</b><br /><b>{title}</b>
                        <div style={{ marginTop: 4 }}>
                          <button
                            onClick={() => {
                              if (isProforma) {
                                onDetailClickPro(id);
                              } else {
                                onDetailClick(id_livraison, NumCommande);
                              }
                            }}
                            style={{
                              fontSize: '10px',
                              padding: '2px 6px',
                              background: '#17a2b8',
                              color: '#fff',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                            }}
                          >
                            📄 Détail
                          </button>
                        </div>
                      </div>
                    );
                  }}
                  eventDidMount={(info) => {
                    const dateEx = new Date(info.event.start);
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    dateEx.setHours(0, 0, 0, 0);

                    if (dateEx < today) {
                      info.el.style.backgroundColor = "rgba(255, 0, 0, 0.2)";
                      info.el.style.borderColor = "rgba(255, 0, 0, 0.6)";
                    } else {
                      // jaune si aujourd'hui ou futur
                      info.el.style.backgroundColor = "rgba(255, 255, 0, 0.3)";
                      info.el.style.borderColor = "rgba(255, 255, 0, 0.6)";
                    }
                  }}



                  height="auto"
                />
              ) : <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "300px", // adjust as needed
                }}
              >
                <div
                  style={{
                    border: "4px solid #f3f3f3",
                    borderTop: "4px solid #3285c6",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    animation: "spin 1s linear infinite",
                  }}
                />
                <style>
                  {`
        @keyframes spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
      `}
                </style>
              </div>}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>

  );
}

export default ListCalendrierLivraison;
